module.exports = __webpack_public_path__ + "static/media/banner_new_pago_rapido_mobile_375.354e2d2c.png";